/**
 * Maps UI sort order values to RDS API sort_order ('asc' | 'desc').
 * @param {string} sortOrder
 * @returns {'asc' | 'desc'}
 */
export const mapLawftIdSortOrder = (sortOrder) => {
  if (sortOrder === 'alphabet_descending' || sortOrder === 'desc') {
    return 'desc';
  }
  return 'asc';
};

/**
 * Maps a single Lawft ID item from the RDS API shape to the legacy frontend shape.
 * @param {Object} item - Lawft ID record from RDS list response
 * @returns {Object}
 */
export const mapLawftIdItem = (item = {}) => {
  const practiceAreas = item.practice_areas ?? item.practice_area_id ?? [];

  const practice_area_id = practiceAreas
    .map((pa) => {
      if (typeof pa === 'string') {
        return pa.startsWith('practice_area#') ? pa : `practice_area#${pa}`;
      }
      const id = pa?.practice_area_id || pa?.id || '';
      return id.startsWith('practice_area#') ? id : `practice_area#${id}`;
    })
    .filter(Boolean);

  return {
    ...item,
    practice_area_id,
    lawft_id_status: item.status ?? item.lawft_id_status,
  };
};

/**
 * Normalizes the Lawft ID RDS list API response for existing consumers.
 * RDS shape: { total_count, data[], page, limit, page_count, has_next, has_previous }
 * @param {Object} response - Axios response from listLawftIds
 * @returns {Object}
 */
export const mapLawftIdListResponse = (response) => {
  const apiData = response?.data || {};
  const items = (apiData.data || apiData.lawft_id || []).map(mapLawftIdItem);

  return {
    ...response,
    data: {
      ...apiData,
      lawft_id: items,
      data: items,
    },
  };
};
